import format from "date-fns/format";

export const dateToISOWithoutTimezone = (date: Date) =>
  `${format(date, "yyyy-MM-dd")}T00:00:00`;
